module.exports = __webpack_public_path__ + "static/media/simplonbp-light-webfont.65ef30ef.ttf";